import { useMemo } from 'react';
import { IQueryLike } from '../../components/QueriesLoaded';

export const useQueriesFetched = (queries: IQueryLike<any>[]) => {
  return useMemo(() => {
    return queries.every((p) => p.isFetched);
  }, [queries]);
};
